import CustomIcon from "./CustomIcon";
import React from "react";


const PlatformToggle = ({mobileView, mobileOnClick, webOnClick}) => {
  return <div className="flex border py-1 px-1 app-rounded">
    <div className={`${mobileView ? "bg-sky-100" : ""} py-1.5 px-2 flex items-center app-rounded`}>
      <CustomIcon icon="phone_iphone" size="xl"
                  className={mobileView ? 'text-secondary-500' : 'text-rand-200 cursor-pointer'}
                  onClick={mobileOnClick}/>
    </div>
    <div className={`${mobileView ? "" : "bg-sky-100"} py-1.5 px-2 flex items-center app-rounded`}>
      <CustomIcon icon="desktop_mac" size="xl"
                  className={mobileView ? 'text-rand-200 cursor-pointer' : 'text-secondary-500'}
                  onClick={webOnClick}/>
    </div>
  </div>
}


export default PlatformToggle